export type CheckinFunctionIdType = (typeof CheckinFunctionIdType)[keyof typeof CheckinFunctionIdType];
export const CheckinFunctionIdType = {
  CHECKIN: 'C01',
  BOARDING_PROCEDURES: 'C02',
} as const;
